import { Icon } from "components/icon";
import { defaultLinkStyle } from "components/ui/link";
import { FindOrCreateCommunityInsightsMutation } from "generated/graphql";
import React from "react";
import { PhoneSingleNumber } from "util/phone-display";

interface CommunityDetailsProps {
    listing: FindOrCreateCommunityInsightsMutation["findOrCreateCommunityInsights"];
}

export const CommunityInsightsDetails = ({ listing }: CommunityDetailsProps) => {
    return (
        <>
            <div className="flex items-center justify-between mb-4">
                <div className="flex items-center space-x-2">
                    <div className="w-7">
                        <Icon name="57_Community" />
                    </div>
                    <span className="text-lg text-gray-700">Community Details</span>
                </div>
            </div>
            <p className="mb-2">
                <strong>Name:</strong> {listing.name}
            </p>
            <p className="mb-2">
                <strong>Address:</strong> {listing.address} {listing.city},{" "}
                {listing.state} {listing.zip}
            </p>
            {listing.website ? (
                <p className="mb-2">
                    <strong>Website:</strong>{" "}
                    <a
                        href={listing.website}
                        className={`${defaultLinkStyle} break-all`}
                        target="_blank"
                        rel="noreferrer">
                        {listing.website}
                    </a>
                </p>
            ) : null}
            {listing.phoneNumbers?.map(phoneNumber => (
                <div
                    className="mb-2 flex items-center space-x-1"
                    key={phoneNumber.number}>
                    <strong>{phoneNumber.label || "Phone"}:</strong>{" "}
                    <PhoneSingleNumber phoneNumber={phoneNumber.number} />
                </div>
            ))}
        </>
    );
};
